import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { LoginTheme } from '../../../themeConstants'

const styles = StyleSheet.create({
    containerGeneral: {
        flex: 1,
        backgroundColor: LoginTheme.loginBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    container: {
        flex: 1,
        width: '100%',
        paddingHorizontal: 12,
        paddingVertical: 48,
    },
    containerFlex: {
        flex: 1,
    },
    containerLogin: {
        flex: 1,
        width: '100%',
        justifyContent: 'space-between',
        padding: 12,
    },
    containerCreateUser: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    opacity: {
        opacity: 1,
    },
    checkbox: {
        width: 14,
        height: 14,
        borderWidth: 2,
        borderRadius: 7,
        borderColor: theme.colors.colorPrimary,
        marginRight: 6,
    },
    gender: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    selectedGender: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    textContainer: {
        alignItems: 'flex-start',
        width: '100%',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        textAlign: 'left',
        color: LoginTheme.loginTextcolor,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 20,
        paddingHorizontal: 12,
    },
    paddingTitle: {
        paddingBottom: 8,
        paddingRight: 8,
    },
    paddingTitleBis: {
        paddingBottom: 0,
        paddingRight: 8,
    },
    version: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'center',
        color: theme.colors.textSecondary,
        marginBottom: 12,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        textAlign: 'left',
        color: LoginTheme.loginTextcolor,
        marginBottom: 24,
    },
    paddingTop: {
        paddingTop: 8,
    },
    containerNote: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
    paddingNote: {
        paddingBottom: 4,
        paddingRight: 4,
    },
    paddingNoteBis: {
        paddingBottom: 12,
        paddingRight: 8,
    },
    note: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textSecondary,
    },
    alignStart: {
        alignSelf: 'flex-start',
    },
    inputContainer: {
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: 15,
    },
    inputTitle: {
        width: '100%',
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 4,
        textAlign: 'left',
        color: LoginTheme.loginTextcolor,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 0,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: theme.colors.inputBackground,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginTop: 0,
    },
    marginBottom: {
        marginBottom: 20,
    },
    marginBottomBis: {
        marginBottom: 8,
    },
    genderBlock: {},
    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semi-transparente
    },
    modalContainer: {
        width: '80%',
        backgroundColor: 'white',
        borderRadius: 10,
        paddingHorizontal: 12,
        paddingVertical: 20,
        alignItems: 'center',
        elevation: 5, // Sombra para Android
        shadowColor: 'black', // Sombra para iOS
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 4,
    },
    input_verification: {
        width: '100%',
        height: 40,
        borderColor: theme.colors.lightGray,
        borderWidth: 0.5,
        borderRadius: 5,
        paddingHorizontal: 12,
        marginBottom: 12,
    },
    inputVerification: {
        flex: 1,
        height: 40,
        borderWidth: 0,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 10,
        backgroundColor: theme.colors.inputBackground,
        paddingHorizontal: 10,
        marginTop: 4,
        marginBottom: 15,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        color: theme.colors.textPrimary,
    },
    modalSubtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        marginBottom: 15,
        color: theme.colors.textSecondary,
    },
    input: {
        flex: 1,
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
    },
    numberPrefix: {
        marginRight: 10,
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    image: {
        width: LoginTheme.clientLogoWidth,
        height: LoginTheme.clientLogoHeight,
        alignSelf: 'center',
        marginBottom: LoginTheme.clientLogoMarginBottom,
    },
    icon_text: {
        fontSize: 18,
        textAlign: 'left',
        color: theme.colors.textSecondary,
        marginBottom: 25,
        marginTop: -35,
    },
    errorMessage: {
        fontSize: 14,
        width: '100%',
        textAlign: 'center',
        color: LoginTheme.errorMessageTextColor,
        paddingBottom: 10,
    },
    paddingErrorMessage: {
        paddingTop: 10,
    },
    button: {
        flexDirection: 'column',
        width: '100%',
        paddingTop: 28,
        paddingBottom: 16,
    },
    buttonText: {
        fontSize: 14,
        fontWeight: 'bold',
        color: LoginTheme.loginTextcolor,
        width: '100%',
        textAlign: 'right',
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    mainButton: {
        height: 40,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 5,
    },
    mainButtonText: {
        fontSize: 15,
        color: LoginTheme.mainButtonTextColor,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        borderWidth: 2,
        borderColor: LoginTheme.backButtonTextColor,
        paddingVertical: 8,
        paddingHorizontal: 50,
        borderRadius: 10,
    },
    borderButtonText: {
        color: LoginTheme.backButtonTextColor,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    switchButton: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    switchButtonText: {
        flex: 1,
        color: theme.colors.inputPlaceholder,
        fontWeight: 'normal',
        fontSize: 15,
        textAlign: 'center',
        marginRight: 10,
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 0,
    },
    genderContainer: {
        flexDirection: 'row',
        width: '100%',
    },
    genderButton: {
        paddingVertical: 5,
        marginRight: 16,
    },
    selectedGenderButton: {
        backgroundColor: theme.colors.colorPrimary,
    },
    genderButtonText: {
        color: 'white',
    },
    containerModal: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerEditModal: {
        flex: 2.5,
        justifyContent: 'center',
        alignItems: 'center',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        backgroundColor: 'white',
    },
    borderRedButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.error,
        padding: 8,
        borderRadius: 10,
    },
    borderRedButtonText: {
        fontSize: 16,
        color: theme.colors.error,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
    //loginBiometric
    start: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        textAlign: 'left',
        color: theme.colors.textSecondary,
    },
    containerUser: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        borderWidth: 1.0,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
    },
    avatar: {
        width: 48,
        height: 48,
        borderRadius: 24,
    },
    username: {
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'left',
        color: theme.colors.textPrimary,
    },
    email: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textPrimary,
    },
    lastConnection: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left',
        color: theme.colors.textSecondary,
    },
    floatingButtonText: {
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.colorPrimary,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    spacer: {
        height: 4,
    },
    customView: {
        position: 'absolute',
        inset: 0, // top: 0, right: 0, bottom: 0, left: 0
        justifyContent: 'center', // Centra vertical
        alignItems: 'center', // Centra horizontal
    },

    // La tarjeta del bottom sheet (mantiene tu estilo original)
    bottomSheetCard: {
        backgroundColor: 'white',
        borderRadius: 15,
        overflow: 'hidden',
        maxWidth: 436,
    },
})

export default styles
